import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får personalen få alkohol gratis eller till rabatt?";
const SHORT_ANSWER = "Personalrabatt eller fri dryck efter arbetspasset i begränsad omfattning är tillåtet, men ska dokumenteras och får inte ske under arbetstid.";

export const Route = createFileRoute("/fraga/far-jag-anvanda-personalrabatt")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får personalen få alkohol gratis eller till rabatt" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Personalen ska följa samma serveringsregler som gäster när det gäller berusningsnivå. Kassaregister och bokföring ska hantera personalförsäljning korrekt."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Alkohollagen och personalförmåner" }}
      related={[{"to": "/fraga/vad-ar-egenkontrollprogram", "label": "Vad är ett egenkontrollprogram?"}, {"to": "/fraga/vilka-anteckningar-maste-jag-fora", "label": "Vilka anteckningar måste jag föra i verksamheten?"}, {"to": "/fraga/vad-galler-for-prissattning", "label": "Får jag sänka alkoholpriserna hur mycket jag vill?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får personalen få alkohol gratis eller till rabatt?" },
      { name: "description", content: "Personalrabatt eller fri dryck efter arbetspasset i begränsad omfattning är tillåtet, men ska dokumenteras och får inte ske under arbetstid." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-anvanda-personalrabatt" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-anvanda-personalrabatt" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-anvanda-personalrabatt",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får personalen få alkohol gratis eller till rabatt", url: "https://alkoholprovet.se/fraga/far-jag-anvanda-personalrabatt" },
      ]),
    ],
  }),
});
